export const faceLivenessMovementDelay = 3000;
export const faceLivenessMovementDuration = 3000;
